import React from 'react';
import { Origin } from '../../manage-installed-apps-page';
import { MessageBoxFunctionalLayout, Modal, TextButton } from 'wix-style-react';
export var DeletePageAppModal = function (_a) {
    var app = _a.app, origin = _a.origin, editorUrl = _a.editorUrl, handleClose = _a.handleClose, t = _a.t;
    var title = t('manage-apps.delete-page-header', {
        name: app.webSolutionBase.name,
    }).replace('&amp;', '&');
    var learnMoreTextButton = (React.createElement(TextButton, { as: "a", href: t('manage-apps.delete-page-cta-link'), target: "_blank", onClick: handleClose }, t('manage-apps.delete-page-side-cta')));
    var confirmText = origin === Origin.EDITOR
        ? t('manage-apps.delete-page-editor-cta')
        : t('manage-apps.delete-page-dashboard-cta');
    var onOkClick = function () {
        if (origin === Origin.BIZMGR) {
            window.open(editorUrl, '_blank');
        }
        handleClose();
    };
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(MessageBoxFunctionalLayout, { closeButton: true, theme: "blue", title: title, sideActions: learnMoreTextButton, confirmText: confirmText, onOk: onOkClick, onClose: handleClose, dataHook: "delete-page-app-modal" },
            t('manage-apps.delete-page-line1'),
            React.createElement("br", null),
            t('manage-apps.delete-page-line2'),
            React.createElement("br", null),
            t('manage-apps.delete-page-line3'),
            React.createElement("br", null),
            t('manage-apps.delete-page-line4'))));
};
//# sourceMappingURL=delete-page-modal.js.map